import { render } from "./SellerRegister.vue?vue&type=template&id=04552c41&scoped=true"
import script from "./SellerRegister.vue?vue&type=script&lang=js"
export * from "./SellerRegister.vue?vue&type=script&lang=js"

import "./SellerRegister.vue?vue&type=style&index=0&id=04552c41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04552c41"]])

export default __exports__